import fscreen from "fscreen";
import { createSlice } from "@reduxjs/toolkit";
import {
  joinSpaceChannel,
  leaveExistingSpaceChannel,
  sendChatMsg,
  sendFocus,
  sendKickFromSpace,
  sendLockSpace,
  sendMembersChatable,
  sendMembersLocked,
  sendMembersMuted,
  sendMembersShoutable,
  sendMove,
  sendPersonLocked,
  sendPersonMuted,
  sendPersonShoutable,
  sendPinnedShare,
  sendShout,
  setEnterButtonLoading,
} from "./channels/spaceChannelSlice";
import {
  loadGraphicSpace,
  onWindowChangeSpace,
  setGraphicMe,
  unloadGraphicSpace,
} from "space/spaceSetUp";
import {
  resetSpaceMediaSlice,
  setMeAdmin,
  setMembersMuted,
  setMembersShoutable,
  setMePerson,
  setMeShout,
  setMeShoutable,
  setMutedForMe,
  setRemoteAdmin,
  setRemoteShoutable,
  setSpaceInitPack,
  stopMediaLoop,
  hideSpaceBox,
  showSpaceBox,
  startMediaLoop,
  refreshSpaceMediaSlice,
  selectMyLuid,
  forceHandleSpaceChanges,
  selectMeShout,
  selectMePinnedShare,
  selectMeFocus,
  setMePinnedShare,
  selectSpaceBoxActive,
  setMeLocked,
  setMeBuzzed,
  openToSpaceLayout,
  selectSpaceLayoutValue,
  SPACE_LAYOUT,
  selectMePreFocus,
  setRemoteLocked,
  setMeFocus,
  setMeMuted,
  setRemoteMuted,
  selectMeAdmin,
  selectPeople,
  setMembersLocked,
  selectMeShoutable,
  setMembersChatable,
  selectSpaceSideBar,
  SPACE_CHAT,
  openMyBoard,
  MY_BOARD,
} from "./spaceMediaSlice";
import {
  resetSpaceMyMediaSlice,
  selectMeCamera,
  selectMeMic,
  selectMeSharing,
  selectMeScreenTrackId,
  setMeSharing,
} from "./spaceMyMediaSlice";
import { ADMIN_CODE, MAX_SPACE_CHAT_HISTORY } from "constants/constants";
import { createGraphicPerson } from "space/spaceClasses";
import { testPeople } from "space/spaceTestData";
import {
  graphicPersonLocked,
  graphicBuzzed,
  graphicFocus,
  graphicPinnedShare,
  graphicShout,
  graphicTalking,
} from "space/spaceSignalling";
import { selectPeopleModal, setSpaceRoleId } from "./peopleSlice";
import {
  tryConnectToRoom,
  disconnectFromRoom,
  checkMediaConferenceSupported,
  turnOffMic,
  stopAllDevices,
  turnOnMic,
  turnOnScreen,
  turnOnCamera,
  turnOffScreen,
  handleOtherShare,
} from "./mediaServerSlice";
import {
  resetWebAppWithError,
  selectGuestInfo,
  setGeneralModal,
} from "./generalSlice";
import { isEmptyObject } from "helpers/randomHelpers";
import {
  playBuzzSound,
  playEnterSpaceSound,
  playFocusCallSound,
  playLeftSpaceSound,
  playNewLiveChatSound,
  playUnFocusCallSound,
} from "helpers/sounds";
import { moveIfColliding } from "space/spaceDrag";
import { selectData } from "./efficeCacheSlice";
import {
  selectCurrentUserAttributes,
  selectMyGuid,
  setCurrentUserAttributes,
} from "./authSlice";
import { testDummyData, testDummyDataPeepNumber } from "helpers/dev";
import { graphicUpdateMyDevices } from "./spaceMyMediaSlice";
import dayjs from "dayjs";
let getState = null;
let dispatch = null;
import("Store").then((module) => {
  getState = module.store.getState;
  dispatch = module.store.dispatch;
});

const INITIAL_STATE = {
  spaceNode: null,
  downloadBoard: null,
  closeBoard: null,
  spaceLocked: false,
  newChat: false,
  chatHistory: [],
  gotMyBearings: true,
  spaceFullScreen: false,
};

export const slice = createSlice({
  name: "space",
  initialState: INITIAL_STATE,
  reducers: {
    setSpaceNode: (state, action) => {
      state.spaceNode = action.payload;
    },
    setDownloadBoard: (state, action) => {
      state.downloadBoard = action.payload;
    },
    setCloseBoard: (state, action) => {
      state.closeBoard = action.payload;
    },
    setNewChat: (state, action) => {
      state.newChat = action.payload;
    },
    addToChatHistory: (state, action) => {
      // {
      //   name,
      //   time,
      //   text
      // }
      state.chatHistory.unshift(action.payload);
      if (state.chatHistory.length > MAX_SPACE_CHAT_HISTORY)
        state.chatHistory.pop();
    },
    resetChatHistory: (state) => {
      state.chatHistory = [];
    },
    setSpaceLocked: (state, action) => {
      state.spaceLocked = action.payload;
    },
    setGotMyBearings: (state, action) => {
      state.gotMyBearings = action.payload;
    },
    setSpaceFullScreen: (state, action) => {
      state.spaceFullScreen = action.payload;
    },
    resetSpaceSlice: () => INITIAL_STATE,
  },
});

export const {
  setSpaceNode,
  setDownloadBoard,
  setCloseBoard,
  setNewChat,
  addToChatHistory,
  resetChatHistory,
  setSpaceLocked,
  setGotMyBearings,
  setSpaceFullScreen,
  resetSpaceSlice,
} = slice.actions;

export const selectCurrentSpaceId = (state) =>
  state.space.spaceNode ? state.space.spaceNode.id : null;
export const selectCurrentSpacePermId = (state) =>
  state.space.spaceNode ? state.space.spaceNode.permissions_id : null;
export const selectSpaceNode = (state) => state.space.spaceNode;
export const selectDownloadBoard = (state) => state.space.downloadBoard;
export const selectCloseBoard = (state) => state.space.closeBoard;
export const selectNewChat = (state) => state.space.newChat;
export const selectChatHistory = (state) => state.space.chatHistory;
export const selectSpaceLocked = (state) => state.space.spaceLocked;
export const selectGotMyBearings = (state) => state.space.gotMyBearings;
export const selectSpaceFullScreen = (state) => state.space.spaceFullScreen;

export async function joinSpace(efficeID) {
  if (!checkMediaConferenceSupported()) {
    dispatch(
      setGeneralModal({
        title:
          "This browser does not support live video and audio communication.",
        content:
          "Please sign in on a modern desktop browser such as Google Chrome, Safari, Microsoft Edge or Firefox. For iOS please use Safari. For Android please use Chrome.",
      })
    );
    return;
  }
  dispatch(setEnterButtonLoading(true));

  if (selectSpaceNode(getState())) {
    await leaveSpace();
    joinSpaceChannel(efficeID);
  } else {
    joinSpaceChannel(efficeID);
  }
}

export async function initialiseSpace({ space_state, pos, token }) {
  window.efs_debug && window.log("INITALISING SPACE");
  if (selectSpaceNode(getState())) {
    window.log("SPACE ALREADY INITIALISED, UNLOADING PREVIOUS");
    stopMediaLoop();
    await disconnectFromRoom(); // questionable
    dispatch(refreshSpaceMediaSlice());
    dispatch(resetSpaceMyMediaSlice());
    // leaveExistingSpaceChannel();
    unloadGraphicSpace();
    // playLeftSpaceSound();
  }

  let receivedPeople = space_state.people;

  dispatch(
    setSpaceInitPack({
      room_url: space_state.room_url,
      membersMuted: space_state.members_muted,
      membersShoutable: space_state.members_shoutable,
      membersChatable: space_state.members_chatable,
      membersLocked: space_state.members_locked,
    })
  );
  dispatch(setSpaceLocked(space_state.space_locked));

  const guestInfo = selectGuestInfo(getState());
  console.log(guestInfo);
  console.log(receivedPeople);
  console.log(selectCurrentUserAttributes(getState()));
  if (guestInfo) {
    if (!selectMyGuid(getState())) {
      for (var lid in receivedPeople) {
        if (guestInfo.guid === receivedPeople[lid].uuid) {
          dispatch(
            setCurrentUserAttributes({
              id: receivedPeople[lid].uuid,
              email: "",
              avatar_key: receivedPeople[lid].avatar_key,
              given_name: receivedPeople[lid].given_name,
              family_name: receivedPeople[lid].family_name,
              licence_expiry: "2200-03-10T09:39:44Z",
              licence_type: "SEED",
            })
          );
        }
      }
    }
  }
  let myUuid = selectMyGuid(getState());
  if (!myUuid) {
    resetWebAppWithError("Error", "Could not enter.");
    return;
  }

  for (var luid in receivedPeople) {
    if (myUuid === receivedPeople[luid].uuid) {
      const me = createGraphicPerson(
        receivedPeople[luid].admin,
        receivedPeople[luid].avatar_key,
        receivedPeople[luid].family_name,
        receivedPeople[luid].given_name,
        false,
        false,
        false,
        receivedPeople[luid].luid.toString(),
        receivedPeople[luid].muted,
        receivedPeople[luid].shout,
        receivedPeople[luid].pinned_share,
        receivedPeople[luid].shoutable,
        receivedPeople[luid].locked,
        receivedPeople[luid].focus,
        receivedPeople[luid].buzzed,
        receivedPeople[luid].uuid,
        pos[luid][0],
        pos[luid][1]
      );
      dispatch(setMePerson(me));
      setGraphicMe(me);
    } else {
      // check positions available
      handleRemoteJoin({
        ...receivedPeople[luid],
        x: pos[luid] ? pos[luid][0] : 0,
        y: pos[luid] ? pos[luid][1] : 0,
        luid: receivedPeople[luid].luid.toString(),
      });
    }
  }
  if (testDummyData) {
    for (var i in testPeople) {
      if (i > testDummyDataPeepNumber) break;
      handleRemoteJoin(testPeople[i]);
    }
  }
  loadGraphicSpace();
  dispatch(setGotMyBearings(false));

  tryConnectToRoom({ room_url: space_state.room_url, token: token })
    .then((meetingLive) => {
      // throw new Error();
      window.efs_debug &&
        window.log(
          "tryConnect Complete. MeetingLive: " + JSON.stringify(meetingLive)
        );
      startMediaLoop();
      dispatch(setSpaceNode(selectData(getState())[space_state.space_id]));

      //to slide in spacebox first

      // setTimeout(() => {
      haveEnteredSpace();
      showSpaceBox();
      window.efs_debug && window.log("Successfully loaded space");
      // }, 600);
    })
    .catch(() => {
      leaveSpace();
    })
    .finally(() => {
      dispatch(setEnterButtonLoading(false));
      setTimeout(() => {
        dispatch(setGotMyBearings(true));
      }, 5000);
    });
}

function haveEnteredSpace() {
  playEnterSpaceSound();
  // setTimeout(() => {
  // // since after being added there is some time for the remote clients to process the new people
  // console.log("HAVE ENTERED SPACE MOVE IF COLIGDE");
  if (selectSpaceNode(getState())) moveIfColliding(true);
  // }, MEDIA_LOOP_INTERVAL * 2);
}

export async function leaveSpace() {
  window.efs_debug && window.log("Leave Space Called");

  exitFullScreen();
  if (selectSpaceNode(getState())) {
    stopMediaLoop();
    await disconnectFromRoom();
    dispatch(setSpaceNode(null));
    dispatch(resetSpaceSlice());
    dispatch(resetSpaceMediaSlice());
    dispatch(resetSpaceMyMediaSlice());
    await leaveExistingSpaceChannel();
    unloadGraphicSpace();
    playLeftSpaceSound();
    resetPeopleQueues();
  } else {
    window.efs_debug && window.log("There was no space to leave");
  }
  hideSpaceBox();
}

//#region ////// HANDLERS OF CLIENT INITIATED SPACE EVENTS

export const move = (x_pos, y_pos) => {
  sendMove(x_pos, y_pos);
};

export const turnOffShout = () => {
  sendShout(false);
};

export const turnOnShout = () => {
  if (selectMeFocus(getState())) turnOffFocus();
  if (getState().spaceMedia.meShoutable) sendShout(true);
};

export const turnOffPinnedShare = () => {
  dispatch(setMePinnedShare(false));
  sendPinnedShare(false);
};

export const turnOnPinnedShare = () => {
  if (selectMeShoutable(getState())) dispatch(setMePinnedShare(true));
  if (
    selectMeScreenTrackId(getState()) ||
    selectMeSharing(getState()) === "board"
  )
    sendPinnedShare(true);
};

export const turnOffShare = () => {
  turnOffPinnedShare();
  if (selectMeSharing(getState()) === "screen") turnOffScreen();
  if (selectMeSharing(getState()) === "board") turnOffBoard();
};

export function turnOffBoard() {
  dispatch(setMeSharing(null));
  if (selectSpaceLayoutValue(getState()) === MY_BOARD) openToSpaceLayout();
}

export function turnOnBoard() {
  if (selectMeFocus(getState())) turnOffFocus();
  dispatch(setMeSharing("board"));
  openMyBoard();
}

export const turnOffFocus = () => {
  window.efs_debug && window.log("Will try turn off focus");

  if (selectMeFocus(getState())) {
    sendFocus(false);
    dispatch(setMeFocus({ value: false }));
    dispatch(setMeBuzzed(0));
    graphicFocus(selectMyLuid(getState()), false);
    graphicBuzzed(selectMyLuid(getState()), 0);
  }
};

export const turnOnPreFocus = () => {
  let { mic, cam, screen } = selectMePreFocus(getState());
  if (mic) turnOnMic();
  if (screen) turnOnScreen();
  if (cam) turnOnCamera();
};

export const turnOnFocus = () => {
  if (selectMeShout(getState())) sendShout(false);
  if (selectMePinnedShare(getState())) sendPinnedShare(false);
  if (selectSpaceLayoutValue(getState()) !== SPACE_LAYOUT) openToSpaceLayout();

  dispatch(
    setMeFocus({
      value: true,
      mePreFocus: {
        mic: selectMeMic(getState()),
        cam: selectMeCamera(getState()),
        screen: false,
      },
    })
  );
  graphicFocus(selectMyLuid(getState()), true);
  stopAllDevices();
  // focus sent before so that sounds plays for people
  sendFocus(true);
  moveIfColliding(false, 3.5);
};

export const muteForMe = (luid) =>
  dispatch(setMutedForMe({ luid: luid, value: true }));

export const unmuteForMe = (luid) =>
  dispatch(setMutedForMe({ luid: luid, value: false }));

export const muteForAll = (luid) => {
  //debugger;
  if (selectMeAdmin(getState())) sendPersonMuted(luid, true);
};

export const unmuteForAll = (luid) =>
  selectMeAdmin(getState()) ? sendPersonMuted(luid, false) : null;

export const lockPerson = (luid) =>
  selectMeAdmin(getState()) ? sendPersonLocked(luid, true) : null;

export const unlockPerson = (luid) =>
  selectMeAdmin(getState()) ? sendPersonLocked(luid, false) : null;

export const disableShout = (luid) =>
  selectMeAdmin(getState()) ? sendPersonShoutable(luid, false) : null;

export const enableShout = (luid) =>
  selectMeAdmin(getState()) ? sendPersonShoutable(luid, true) : null;

export const kickFromSpace = (luid) =>
  selectMeAdmin(getState()) ? sendKickFromSpace(luid) : null;

export const muteAllMembers = () =>
  selectMeAdmin(getState()) ? sendMembersMuted(true) : null;

export const unmuteAllMembers = () =>
  selectMeAdmin(getState()) ? sendMembersMuted(false) : null;

export const disableShoutForMembers = () =>
  selectMeAdmin(getState()) ? sendMembersShoutable(false) : null;

export const enableShoutForMembers = () =>
  selectMeAdmin(getState()) ? sendMembersShoutable(true) : null;

export const disableChatForMembers = () =>
  selectMeAdmin(getState()) ? sendMembersChatable(false) : null;

export const enableChatForMembers = () =>
  selectMeAdmin(getState()) ? sendMembersChatable(true) : null;

export const lockMembers = () =>
  selectMeAdmin(getState()) ? sendMembersLocked(true) : null;

export const unlockMembers = () =>
  selectMeAdmin(getState()) ? sendMembersLocked(false) : null;

export const lockSpace = () =>
  selectMeAdmin(getState()) ? sendLockSpace(true) : null;

export const unlockSpace = () =>
  selectMeAdmin(getState()) ? sendLockSpace(false) : null;

export const sendChat = (msg) => {
  sendChatMsg(msg);
};

//#endregion

//#region // HANDLERS OF EXTERNAL EVENTS to be coordinated with space_state in PHOENIX

let newPeopleQueue = {};
let leftPeopleQueue = {};

export const resetPeopleQueues = () => {
  newPeopleQueue = {};
  leftPeopleQueue = {};
};
window.getqueues = () => {
  window.log(JSON.stringify(newPeopleQueue, null, 4));
  window.log(JSON.stringify(leftPeopleQueue, null, 4));
};

export const handleRemoteJoin = (person) => {
  let luid = person.luid.toString();

  // When join mark their devices as off until signals received
  let newPerson = createGraphicPerson(
    person.admin,
    person.avatar_key,
    person.family_name,
    person.given_name,
    person.micOn,
    person.camOn,
    person.share,
    luid,
    person.muted,
    person.shout,
    person.pinned_share,
    person.shoutable,
    person.locked,
    person.focus,
    person.buzzed,
    person.uuid,
    person.x,
    person.y
  );

  newPeopleQueue[luid] = newPerson;
  // Incase come leaves then joins quickly
  if (leftPeopleQueue[luid]) delete leftPeopleQueue[luid];
};

export const handleRemoteLeave = (luid) => {
  window.log("HANDLING REMOTE LEAVE");
  if (selectMyLuid(getState()) === luid) {
    leaveSpace();
    resetPeopleQueues();
    return;
  }
  leftPeopleQueue[luid] = true;
  // Incase come joins then leaves quickly
  if (newPeopleQueue[luid]) delete newPeopleQueue[luid];
};
window.handleRemoteLeave = handleRemoteLeave;

export function gatherAnyNewPeopleChanges() {
  if (isEmptyObject(newPeopleQueue)) return null;
  let newPeople = {};
  for (let i in newPeopleQueue) {
    newPeople[i] = { ...newPeopleQueue[i] };
  }
  if (selectSpaceNode(getState())) playEnterSpaceSound();
  newPeopleQueue = {};
  return newPeople;
}

export function gatherAnyLeftPeopleChanges() {
  if (isEmptyObject(leftPeopleQueue)) return null;
  let leftPeople = {};
  for (let i in leftPeopleQueue) {
    leftPeople[i] = { ...leftPeopleQueue[i] };
  }
  playLeftSpaceSound();

  leftPeopleQueue = {};
  return leftPeople;
}

export const handlePersonMuted = (luid, value) => {
  if (luid === selectMyLuid(getState())) {
    turnOffMic();
    dispatch(setMeMuted(value));
  } else dispatch(setRemoteMuted({ luid, value }));
};

export const handleRemoteShout = (luid, value) => {
  if (luid === selectMyLuid(getState())) dispatch(setMeShout(value));
  graphicShout(luid, value);
};

export const handleShare = (luid, value) => {
  if (!thisIsMe(luid)) {
    handleOtherShare(luid, value);
  } else {
    graphicUpdateMyDevices();
  }
};

export const handleRemotePinnedShare = (luid, value) => {
  graphicPinnedShare(luid, value);
};

export const handleChatMsg = (luid, value) => {
  window.efs_debug &&
    window.log(
      "Handling Chat Message: " +
        JSON.stringify(luid, null, 4) +
        " " +
        JSON.stringify(value, null, 4)
    );
  let time = dayjs(Date.now()).format("HH:mm");
  let text = value;

  if (luid === selectMyLuid(getState())) {
    let name =
      selectCurrentUserAttributes(getState()).given_name +
      " " +
      selectCurrentUserAttributes(getState()).family_name;

    dispatch(addToChatHistory({ name, time, text }));
  } else if (selectPeople(getState())[luid]) {
    let name =
      selectPeople(getState())[luid].given_name +
      " " +
      selectPeople(getState())[luid].family_name;
    dispatch(addToChatHistory({ name, time, text }));
    if (
      selectSpaceSideBar(getState()) !== SPACE_CHAT &&
      luid !== selectMyLuid(getState())
    ) {
      if (!selectNewChat(getState())) {
        dispatch(setNewChat(true));
        playNewLiveChatSound();
      }
    }
  }
};

export const handleRemoteTalking = (luid, value) => graphicTalking(luid, value);

export const handleRemoteFocus = (luid, value) => {
  if (luid !== selectMyLuid(getState())) graphicFocus(luid, value);
  else {
    if (value) playFocusCallSound();
    else playUnFocusCallSound();
  }
};

export const handleRemoteBuzzed = (luid, value) => {
  if (luid === selectMyLuid(getState())) {
    dispatch(setMeBuzzed(value));
    if (value > 0) playBuzzSound(luid);
  }
  graphicBuzzed(luid, value);
};

export const handlePersonShoutable = (luid, value) => {
  if (luid === selectMyLuid(getState())) {
    dispatch(setMeShoutable(value));
    if (!value) {
      dispatch(setMeShout(false));
      dispatch(setMePinnedShare(false));
    }
  } else dispatch(setRemoteShoutable({ luid, value }));

  if (!value) {
    graphicShout(luid, false);
    graphicPinnedShare(luid, false);
  }
};

export const handlePersonLocked = (luid, value) => {
  if (luid === selectMyLuid(getState())) dispatch(setMeLocked(value));
  else dispatch(setRemoteLocked({ luid, value }));
  graphicPersonLocked(luid, value);
};

export const handleMembersMuted = (value) => {
  dispatch(setMembersMuted(value));
  if (!selectMeAdmin(getState()) && value) turnOffMic();
};

export const handleMembersShoutable = (value) => {
  dispatch(setMembersShoutable(value));
  if (!selectMeAdmin(getState()) && !value) {
    graphicShout(selectMyLuid(getState()), false);
    graphicPinnedShare(selectMyLuid(getState()), false);
  }
  if (!value)
    for (let luid in selectPeople(getState()))
      if (!selectPeople(getState())[luid].admin) {
        graphicShout(luid, false);
        graphicPinnedShare(luid, false);
      }
};

export const handleMembersChatable = (value) => {
  dispatch(setMembersChatable(value));
};

export const handleMembersLocked = (value) => {
  dispatch(setMembersLocked(value));
  if (!selectMeAdmin(getState()))
    graphicPersonLocked(selectMyLuid(getState()), value);
  for (let luid in selectPeople(getState()))
    if (!selectPeople(getState())[luid].admin) graphicPersonLocked(luid, value);
};

export const handleSpaceLocked = (value) => {
  dispatch(setSpaceLocked(value));
};

export const handleChangedRoleId = (luid, value) => {
  let admin = value === ADMIN_CODE ? true : false;
  if (luid === selectMyLuid(getState())) {
    dispatch(setMeAdmin(admin));
  } else {
    dispatch(setRemoteAdmin({ luid: luid, value: admin }));
    if (getState().people.peopleModal) {
      let peopleMedia = selectPeople(getState());
      for (var i in peopleMedia) {
        if (
          i === luid &&
          selectPeopleModal(getState()) &&
          selectSpaceBoxActive(getState())
        ) {
          dispatch(setSpaceRoleId({ uuid: peopleMedia[i].uuid, value: value }));
        }
      }
    }
  }
};

export function handleSpaceDeviceChanged(luid) {
  window.log("Room Device Changed Received ");
  if (luid === selectMyLuid(getState())) {
    spaceEnteredFromAnotherDevice();
  } else {
    handleRemoteLeave(luid);
    forceHandleSpaceChanges();
  }
}

export function spaceEnteredFromAnotherDevice() {
  window.log("Space Entered from another device ");

  leaveSpace();
  dispatch(
    setGeneralModal({
      title: "Removed From Space",
      content:
        "You can only be in one space at once. You have entered a space from another tab or device.",
    })
  );
}

export const handleKickedFromSpace = (luid) => {
  window.efs_debug && window.log("HANDLE KICKED FROM SPACE");
  if (selectMyLuid(getState()) === luid) {
    window.efs_debug && window.log("I WAS KICKED FROM SPACE");
    leaveSpace();
    dispatch(
      setGeneralModal({
        title: "You were removed from this space",
        content: "An admin has kicked you out.",
      })
    );
  } else handleRemoteLeave(luid);
};

export const handleLeaveRoom = () => {
  window.efs_debug && window.log("HANDLE LEAVE ROOM");
  disconnectFromRoom();
  dispatch(resetSpaceMyMediaSlice());
};

export const handleAllKicked = () => {
  window.efs_debug && window.log("HANDLE ALL KICKED");
  leaveSpace();
};

//#endregion

//#region Extras

export const thisIsMe = (luid) => luid === selectMyLuid(getState());

// fscreen.fullscreenEnabled === true / false;

// fscreen.fullscreenElement === null / undefined / DOM Element;

fscreen.onfullscreenchange = () => {
  let elem = document.getElementById("space-and-video");
  if (fscreen.fullscreenElement !== null) {
    dispatch(setSpaceFullScreen(true));
    elem.classList.add("fullscreen-open");
    onWindowChangeSpace();
  } else {
    dispatch(setSpaceFullScreen(false));
    elem.classList.remove("fullscreen-open");
    onWindowChangeSpace();
  }
};
fscreen.onfullscreenerror = () => {
  dispatch(
    setGeneralModal({
      title: "Whoops",
      content: "Full screen mode is not supported on this device.",
    })
  );
};

export function openSpaceFullScreen() {
  showSpaceBox();
  fscreen.requestFullscreen(document.getElementById("space-and-video"));
}

export function exitFullScreen() {
  if (fscreen.fullscreenElement) fscreen.exitFullscreen();
}

// on fullscreen open and close detect and set state

//#endregion

export default slice.reducer;
